/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

// eslint-disable-next-line import/prefer-default-export
export const closeIframe = (): void => window.parent.postMessage({ m: 'ti:initialq:exit' }, '*');
